import { work1, work2, work3, work4, work5, work6 } from "../../assets";

export const projectData = [
  {
    id: 1,
    image: work6,
    title: "DU_gram",
    category: "Web Application",
    year: "2024",
    role: "Full-Stack Developer",
    description:
      "DU_gram is a community-based social platform designed specifically for Dominion University students. It enables secure interactions, academic collaboration, and peer engagement within a controlled campus network.",
    stack: [
      "React",
      "Node.js",
      "Express",
      "MongoDB",
      "JWT Authentication",
      "Cloudinary",
      "Tailwind CSS"
    ],
    highlights: [
      "Secure authentication system for student-only access",
      "Real-time interaction features",
      "Profile system and content sharing",
      "Optimized media uploads and performance"
    ],
    demo: "#", // replace with real link later
    repo: "#"
  },

  {
    id: 2,
    image: work2,
    title: "Conversion Landing Page",
    category: "Frontend Development",
    year: "2023",
    role: "UI Engineer",
    description:
      "A modern high-conversion landing page focused on clarity, accessibility, and user engagement. Designed to communicate value instantly and guide visitors toward action.",
    stack: [
      "HTML5",
      "CSS3",
      "JavaScript",
      "Responsive Design",
      "SEO Optimization"
    ],
    highlights: [
      "Pixel-perfect layout implementation",
      "Mobile-first responsive design",
      "Optimized loading speed",
      "Clean typography and UX hierarchy"
    ],
    demo: "#",
    repo: "#"
  },

  {
    id: 3,
    image: work3,
    title: "Product Landing Experience",
    category: "Frontend + Performance",
    year: "2023",
    role: "Frontend Developer",
    description:
      "A performance-optimized landing page engineered to load extremely fast while maintaining strong visual appeal and responsiveness across devices.",
    stack: [
      "React",
      "Vite",
      "CSS Modules",
      "Lazy Loading",
      "Performance Optimization"
    ],
    highlights: [
      "Optimized bundle size",
      "Smooth scroll animations",
      "Cross-browser compatibility",
      "Accessibility friendly"
    ],
    demo: "#",
    repo: "#"
  },

  {
    id: 4,
    image: work4,
    title: "Custom UI System",
    category: "UI/UX Engineering",
    year: "2024",
    role: "Frontend Architect",
    description:
      "A flexible component-driven UI system designed to adapt to different brands and themes while maintaining consistency and usability.",
    stack: [
      "React",
      "Component Architecture",
      "Reusable Components",
      "Design System",
      "Figma to Code"
    ],
    highlights: [
      "Reusable component library",
      "Design system architecture",
      "Consistent UX patterns",
      "Scalable styling system"
    ],
    demo: "#",
    repo: "#"
  },

  {
    id: 5,
    image: work5,
    title: "Creative Interface Playground",
    category: "Experimental UI",
    year: "2024",
    role: "Frontend Developer",
    description:
      "An experimental interface demonstrating advanced creative front-end capabilities including animations, layout experimentation, and unconventional interaction patterns.",
    stack: [
      "JavaScript",
      "CSS Animations",
      "UI Effects",
      "Interactive Design"
    ],
    highlights: [
      "Advanced animation techniques",
      "Interactive UI behaviors",
      "Creative layout experimentation",
      "Dynamic visual feedback"
    ],
    demo: "#",
    repo: "#"
  },

  {
    id: 6,
    image: work1,
    title: "Analytics Dashboard",
    category: "Dashboard Application",
    year: "2024",
    role: "Frontend Developer",
    description:
      "A responsive data dashboard designed to present analytics clearly and efficiently with clean visual hierarchy and intuitive navigation.",
    stack: [
      "React",
      "Charts",
      "Responsive Layout",
      "API Integration",
      "Data Visualization"
    ],
    highlights: [
      "Clean dashboard layout",
      "Dynamic data visualization",
      "Responsive widgets",
      "API data integration"
    ],
    demo: "#",
    repo: "#"
  }
];
